import { BadgeCheck, Bell, CreditCard, LogOut, Sparkles } from "lucide-react";

import { Link, useLocation } from "react-router";
import Cookies from "js-cookie";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "../components/ui/sidebar";
import { fetchUserProfile } from "../utilities/api";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function NavUser() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove tokens
    Cookies.remove("auth_token");
    Cookies.remove("refresh_token");

    // Redirect to login
    navigate("/login");
  };

  const [user, setUser] = useState({ fullName: "", shortName: "" });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const profile = await fetchUserProfile();

        if (profile.fullName && profile.shortName) {
          setUser(profile);
        } else {
          console.warn(" Empty profile received. Check API response.");
        }

        setIsLoading(false);
      } catch (error) {
        console.error(" Error loading user:", error);
        setIsLoading(false);
      }
    };

    loadUser();
  }, []); //  Runs only once on mount
  const { isMobile } = useSidebar();
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              {/* <div className="flex items-center justify-center w-6 h-6 px-1 py-1 rounded-full bg-gold-500">
                        <span className="font-medium text-[10px] leading-4 text-white-50">AB</span>
                </div>
                <div className="grid flex-1 text-sm leading-tight text-left">
                    <span className="font-medium text-sm leading-4.5 text-white-50 truncate">{user.user?.name}</span>
                </div> */}

              <div className="flex flex-row items-center gap-3 min-w-0">
                {/*  ShortName (AB) inside rounded div */}
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gold-500">
                  <span className="font-medium text-[10px] leading-4 text-white-50">
                    {isLoading ? "" : user?.shortName || "??"}{" "}
                    {/* &nbsp to preserve width */}
                  </span>
                </div>

                {/*  Full Name (Dynamic from API) */}
                <div className="grid flex-1 min-w-0 text-sm leading-tight text-left">
                  <span className="font-medium text-sm leading-4.5 text-white-50 truncate block w-[140px]">
                    {isLoading
                      ? "Loading..."
                      : user?.fullName || "Unknown User"}
                  </span>
                </div>
              </div>

              <span href="#" className="flex items-center">
                <img
                  src="/media/images/shevron-left.svg"
                  alt="shevron left"
                  className="w-4 h-4"
                />
              </span>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] bg-gray-50 min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <div className="flex items-center justify-center w-6 h-6 px-1 py-1 rounded-full bg-gold-500">
                  {isLoading ? (
                    <span className="font-medium text-[10px] leading-4 text-white-50">
                      Loading...
                    </span>
                  ) : (
                    <span className="font-medium text-[10px] leading-4 text-white-50">
                      {user?.shortName || "??"}
                    </span>
                  )}
                </div>
                <div className="grid flex-1 text-sm leading-tight text-left">
                  {isLoading ? (
                    <span className="font-medium text-sm leading-4.5 text-gray-900 truncate">
                      Loading...
                    </span>
                  ) : (
                    <span className="font-medium text-sm leading-4.5 text-gray-900 truncate">
                      {user.fullName || "Unknown User"}
                    </span>
                  )}
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem>
                <Sparkles />
                Upgrade to Pro
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem>
                <BadgeCheck />
                <Link to="/my-account">Account</Link>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <CreditCard />
                Billing
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Bell />
                Notifications
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <LogOut />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
